import React, { useEffect } from "react";
import styles from "./OnBoardingLayout.module.css";
import { Outlet } from "react-router-dom";
import { background } from "../../assets/constant";

const OnBoardingLayout = () => {
  useEffect(() => {
    window.history.pushState(null, "", window.location.href)
  }, [])

  return (
    <main className={styles.mainWrapper}>
      <Outlet />
    </main>
  );
};

export default OnBoardingLayout;
